import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Row, Col, Tooltip } from 'antd';
import { IMobileInfo, IPOButton, IPOMessage, MobileInput } from '@hylaa-npm/ipod';

import { ForgetForm } from './style';

import { FormCSS } from '../Login/style';
import randomString from '@/utils/randomString';
import { IShowType } from '../Login';
import { sendCode, verifyCode } from '@/apis/login';
import { IForgetPassword } from '@/container/User';
function ForgetPassword({
	pageChange,
	isToLogin = true,
	handleCancel,
	title = '重置密码',
	mobileLabel = '手机号',
}: ILogInProps & IForgetPassword & { title?: string; mobileLabel?: string }) {
	const { t } = useTranslation();
	const [form] = Form.useForm();
	const [currentCode, setCurrentCode] = useState<string>(randomString(4));
	const [isShowTime, setIsShowTime] = useState<boolean>(false); // 倒计时显示是否是时间
	const [codeTime, setCodeTime] = useState<string>(t('system.getCode'));
	let internal: NodeJS.Timeout | null = null;
	useEffect(() => {
		initDrawCode();
	}, [currentCode]);

	useEffect(() => {
		if (isShowTime) {
			getCodeInterval();
		} else {
			setCodeTime(t('system.getCode'));
		}
		return () => clearInterval(internal as NodeJS.Timeout);
	}, [isShowTime]);
	const getCodeInterval = () => {
		let time = 60;
		internal = setInterval(() => {
			setCodeTime(time.toString() + '秒后获取');
			if (time <= 0) {
				setIsShowTime(false);
				setCodeTime(t('system.getCode'));
				clearInterval(internal as NodeJS.Timeout);
			}
			time--;
		}, 1000);
	};

	const changeCode: () => void = () => {
		const code = randomString(4);
		setCurrentCode(code);
	};
	const getPhoneCode: () => void = async () => {
		let mobileRuest = ((ref.current as unknown) as {
			getValidateRes: () => { res: boolean; mobileInfo: IMobileInfo };
		}).getValidateRes();
		if (!mobileRuest.res) {
			return;
		}
		if (currentCode === form.getFieldValue('verifiCode')) {
			sendCode({
				countryCode: mobileRuest.mobileInfo.areaCode,
				mobile: mobileRuest.mobileInfo.phoneNum,
				type: 'AUTH_FORGET_PASSWORD',
			}).then((res) => {
				setIsShowTime(true);
			});
		} else {
			IPOMessage.error(t('system.plCorrGraphicCode'));
		}
	};
	const initDrawCode: () => void = () => {
		const canvas: HTMLCanvasElement = document.getElementById('verificode') as HTMLCanvasElement;
		if (!canvas.getContext) return;
		// currentCode
		// 获取上下文对象
		const ctx: CanvasRenderingContext2D = canvas.getContext('2d') as CanvasRenderingContext2D;
		// 画一个框
		ctx.beginPath();
		ctx.fillStyle = '#ffab00';
		ctx.fillRect(0, 0, 100, 36);
		ctx.closePath();
		// 画数字
		ctx.beginPath();
		ctx.fillStyle = '#fff';
		ctx.font = '20px sans-serif';
		ctx.fillText(currentCode, 26, 24, 100);
		ctx.closePath();
	};
	const onFinishFailed = (errFrom: { values: { code: string; verifiCode: string } }) => {
		resetPwd(errFrom.values);
	};
	// 下一步重置密码
	const resetPwd: (values: { code: string; verifiCode: string }) => void = async (values) => {
		let mobileRuest = ((ref.current as unknown) as {
			getValidateRes: () => { res: boolean; mobileInfo: IMobileInfo };
		}).getValidateRes();
		if (!mobileRuest.res) {
			IPOMessage.error(t('common.plCorrectPhone'));
			return;
		}
		if (currentCode !== form.getFieldValue('verifiCode')) {
			IPOMessage.error(t('system.plCorrGraphicCode'));
			return;
		}
		if (!values.code) {
			IPOMessage.error(t('system.plPhoneCode'));
			return;
		}
		verifyCode({
			authCode: values.code,
			countryCode: mobileRuest.mobileInfo.areaCode,
			mobile: mobileRuest.mobileInfo.phoneNum,
			type: 'AUTH_FORGET_PASSWORD',
		}).then((res) => {
			pageChange(IShowType.RESET, {
				code: values.code,
				mobile: mobileRuest.mobileInfo.phoneNum,
				areaCode: mobileRuest.mobileInfo.areaCode,
			});
		});
	};
	const ref = useRef();
	return (
		<FormCSS>
			<div className="form-title">{title}</div>
			<ForgetForm>
				<Form
					form={form}
					colon={false}
					labelCol={{ span: 5, offset: 0 }}
					onFinish={resetPwd}
					onFinishFailed={onFinishFailed}>
					<Form.Item label={mobileLabel} name="account">
						<MobileInput mobileRef={ref} />
					</Form.Item>
					<Form.Item
						label={t('system.verifiCode')}
						name="verifiCode"
						rules={[{ required: true, message: '' }]}>
						<div className="dubble-item">
							<Input placeholder={t('system.plGraphicCode')} />
							<Tooltip title="点击可刷新验证码" mouseEnterDelay={1} mouseLeaveDelay={0.5}>
								<canvas
									className="twice-btn"
									id="verificode"
									width="100"
									height="36"
									onClick={() => changeCode()}
								/>
							</Tooltip>
						</div>
					</Form.Item>
					<Form.Item
						label={t('system.SMSCode')}
						name="code"
						className="dubble-item"
						rules={[{ required: true, message: t('system.plPhoneCode') }]}>
						<div className="dubble-item">
							<Input placeholder={t('system.plPhoneCode')} />
							<IPOButton
								onClick={() => getPhoneCode()}
								className="twice-btn"
								type="primary"
								disabled={isShowTime}>
								{codeTime}
							</IPOButton>
						</div>
					</Form.Item>
					<Row className="form-btns">
						<Col span={5}></Col>
						<Col span={19}>
							<IPOButton type="primary" htmlType="submit">
								{t('system.next')}
							</IPOButton>
							{isToLogin ? (
								<Tooltip title="点击可返回登录页面" mouseEnterDelay={3} mouseLeaveDelay={0.5}>
									<IPOButton type="link" onClick={() => pageChange(IShowType.LOGIN)}>
										{t('system.goLogin')}
									</IPOButton>
								</Tooltip>
							) : (
								<IPOButton type="link" onClick={() => handleCancel && handleCancel()}>
									取消
								</IPOButton>
							)}
						</Col>
					</Row>
				</Form>
			</ForgetForm>
		</FormCSS>
	);
}

export default ForgetPassword;
